/**
 * Нормализация URL статических файлов.
 * 
 * Бэкенд сохраняет output_image_url как абсолютный URL с settings.backend_url
 * (например http://localhost:8000/static/results/xxx.png).
 * На фронтенде нужно использовать относительные пути (/static/results/xxx.png),
 * чтобы запросы шли через прокси dev-сервера или nginx.
 * 
 * Также нормализует URL для продакшена (pikly.ru).
 */
export function normalizeStaticUrl(url) {
  if (!url || typeof url !== 'string') return url;

  // Уже относительный — ничего не делаем
  if (url.startsWith('/')) return url;

  try {
    const parsed = new URL(url);
    const pathname = parsed.pathname;

    // Если путь содержит /static/ — берём относительный путь
    if (pathname.includes('/static/')) {
      return pathname + parsed.search;
    }
  } catch {
    // Невалидный URL — возвращаем как есть
  }

  return url;
}
